// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2Eh1D","file":"styles_file__34JWs"};